import React, { useContext } from 'react';
import useLocations from '@ubeya/shared/hooks/account/useLocations';
import ConfigContext from '../../../contexts/ConfigContext';
import { TextWithTooltip } from '../../Tooltip';

const AreasChip = ({ value }) => {
  const { t } = useContext(ConfigContext);
  const { mappedLocations } = useLocations();
  const getName = (areaId) => (areaId === null ? t('noArea') : mappedLocations[areaId]?.name);

  return (
    <TextWithTooltip tooltipBodyMaxWidth={300}>
      {(Array.isArray(value) ? value : [value]).map(getName).filter(Boolean).join(', ')}
    </TextWithTooltip>
  );
};

export default AreasChip;
